import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-trash",
  "use": "icon-trash-usage",
  "viewBox": "0 0 17 18",
  "content": "<symbol viewBox=\"0 0 17 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-trash\"><path d=\"M1 4.583h14.334M6.375 8.166v5.375M9.959 8.166v5.375M1.896 4.583l.895 10.75a1.792 1.792 0 0 0 1.792 1.792h7.167a1.791 1.791 0 0 0 1.791-1.792l.896-10.75M5.479 4.583V1.896A.896.896 0 0 1 6.375 1h3.583a.896.896 0 0 1 .896.896v2.687\" stroke=\"#F78795\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol